<template>
  <a-layout-sider
    theme="light"
    v-if="!getScreen"
    :trigger="null"
    width="320"
    collapsible
    class="d-navigation"
    :style="{ overflow: 'hidden', height: '100vh', position: 'fixed', left: 0 }"
  >
    <div class="d-navigation-profile">
      <div class="m-display-flex flex-row space-between width-full">
        <div class="photos-wrapper">
          <img :src="getAuth.foto" alt="" />
        </div>

        <img
          keep-alive
          class="m-drawer-brand"
          src="@/assets/logo.png"
          alt="brand"
        />
      </div>
      <span>Halo,</span>
      <h3>{{ getAuth.fullname }}</h3>
    </div>

    <ul class="d-navigation-static">
      <li>
        <router-link :to="{ name: 'logout' }">
          <a-icon type="poweroff" />
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'app' }">
          <Icon type="icon-pandapakita" />
        </router-link>
      </li>
      <li>
        <router-link :to="{ name: 'beranda' }">
          <a-icon type="home" />
        </router-link>
      </li>
      <li @click="handleNotification">
        <a-badge
          class="m-badge m-badge-small"
          :count="
            getNotification.aksi.length + getNotification.informasi.length
          "
          :numberStyle="{ backgroundColor: 'red' }"
          :overflowCount="999"
          v-if="
            getNotification.aksi.length > 0 ||
              getNotification.informasi.length > 0
          "
        >
          <a-icon type="notification" />
        </a-badge>
        <a-icon type="notification" v-else />
      </li>
      <li @click="showhideSideBarMenu(isShowhideSideBar)" style="width: auto!important;" v-if="isShowhideSideBar">
        <a-icon type="double-left"/>
      </li>
    </ul>

    <!-- Main Menu -->

    <div class="d-navigation-menu-wrapper">
      <a-spin
        :spinning="loading"
        tip="Preparing Navigation ...  "
        v-if="loading"
      />
      <template v-else>
        <div class="margin-bottom" v-if="specialNavigation.length > 0">
          <span class="d-navigation-title">Special Menu</span>
          <a-menu
            class="d-navigation d-navigation-spesial m-menu"
            :selectedKeys="[current]"
            theme="light"
            mode="inline"
            @click="handleSpesialMenu"
          >
            <a-menu-item v-for="menu in specialNavigation" :key="menu.id_menu">
              <router-link :to="menu.link_menu">
                <a-icon :type="menu.icon_menu" />
                <span>{{ menu.label_menu }}</span>
                <a-badge :dot="parentCount(menu)"></a-badge>
              </router-link>
            </a-menu-item>
          </a-menu>
        </div>
        <div>
          <span class="d-navigation-title">Default Menu</span>
          <a-menu
            class="d-navigation m-menu"
            @click="handleMenu"
            :selectedKeys="[current]"
            theme="light"
            mode="inline"
            v-for="menu in navigation.child"
            :key="menu.id_menu"
          >
            <a-menu-item
              :key="menu.id_menu"
              v-if="menu.child.length <= 0 && menu.id_menu !== '75'"
            >
              <router-link :to="menu.link_menu">
                <a-icon :type="menu.icon_menu" />
                <span>{{ menu.label_menu }}</span>
              </router-link>
            </a-menu-item>
            <a-sub-menu :key="menu.id_menu" v-else-if="menu.id_menu !== '75'">
              <span slot="title">
                <a-icon :type="menu.icon_menu" />
                <span>{{ menu.label_menu }}</span>
              </span>
              <a-menu-item
                v-for="childmenu in menu.child"
                :key="childmenu.id_menu"
              >
                <router-link :to="childmenu.link_menu">
                  <a-icon :type="childmenu.icon_menu" />
                  <span>{{ childmenu.label_menu }}</span>
                </router-link>
              </a-menu-item>
            </a-sub-menu>
          </a-menu>
        </div>
      </template>
    </div>

    <div class="d-navigation-helpdesk" @click="handleHelp">
      <a-icon type="question-circle" /> Helpdesk
    </div>
    <div class="d-navigation-footer" @click="handleVersionChanges">© Simfoni {{ appVersion }}</div>
  </a-layout-sider>

  <!-- Mobile Menu -->

  <a-drawer
    v-else-if="getScreen"
    placement="left"
    :closable="false"
    @close="onClose"
    :visible="getDrawer"
    wrapClassName="m-drawer"
  >
    <div class="m-drawer-header" slot="title">
      <img class="m-drawer-brand" src="@/assets/logo.png" alt="brand" />
      <div class="m-drawer-helpdesk" @click="handleHelp">
        <a-icon type="question-circle" />
      </div>
    </div>
    <div class="m-drawer-body mobile-menu">
      <div class="d-navigation-special" v-if="specialNavigation.length > 0">
        <span class="d-navigation-title">Special Menu</span>
        <a-menu
          class="d-navigation m-menu"
          :selectedKeys="[current]"
          theme="light"
          mode="inline"
          v-for="menu in specialNavigation"
          :key="menu.id_menu"
          @click="handleSpesialMenu"
        >
          <a-menu-item :key="menu.id_menu">
            <router-link :to="menu.link_menu">
              <a-icon :type="menu.icon_menu" />
              <span>{{ menu.label_menu }}</span>
              <a-badge :dot="parentCount(menu)"></a-badge>
            </router-link>
          </a-menu-item>
        </a-menu>
      </div>

      <div class="d-navigation-global">
        <span class="d-navigation-title">Default Menu</span>
        <a-menu
          class="d-navigation m-menu"
          @click="handleMenu"
          :selectedKeys="[current]"
          theme="light"
          mode="inline"
          v-for="menu in navigation.child"
          :key="menu.id_menu"
        >
          <a-menu-item :key="menu.id_menu" v-if="menu.child.length <= 0">
            <router-link :to="menu.link_menu">
              <a-icon :type="menu.icon_menu" />
              <span>{{ menu.label_menu }}</span>
            </router-link>
          </a-menu-item>
          <a-sub-menu :key="menu.id_menu" v-else>
            <span slot="title">
              <a-icon :type="menu.icon_menu" />
              <span>{{ menu.label_menu }}</span>
            </span>
            <a-menu-item
              v-for="childmenu in menu.child"
              :key="childmenu.id_menu"
            >
              <router-link :to="childmenu.link_menu">
                <a-icon :type="childmenu.icon_menu" />
                <span>{{ childmenu.label_menu }}</span>
              </router-link>
            </a-menu-item>
          </a-sub-menu>
        </a-menu>
      </div>
    </div>
  </a-drawer>
</template>

<script>
import Axios from "axios";
import { mapGetters, mapActions } from "vuex";
import GlobalMethod from "@/mixins/GlobalMethod.js";
import notificationCount from "@/mixins/NotificationCount";
import _ from "lodash";

export default {
  name: "Navigation",
  data() {
    return {
      current: "1",
      header: [],
      toggle: false,
      navigation: [],
      specialNavigation: [],
      notification: false,
      loading: false,
    };
  },
  mixins: [GlobalMethod, notificationCount],
  computed: {
    ...mapGetters([
      "getDrawer",
      "getScreen",
      "getAuth",
      "getNavigation",
      "getNotification",
      "getNotificationView",
      "appVersion",
    ]),
    isShowhideSideBar(){
      return this.$store.state.showhideSideBar
    }
  },
  async created() {
    await this.fetchNav();
  },
  methods: {
    ...mapActions(["DRAWER_TOGGLE", "NAVIGATION_ACTION"]),
    handleSpesialMenu(e) {
      localStorage.setItem("nvky", e.key);
      const navLink = _.filter(this.getNavigation, { id_menu: e.key });
      localStorage.setItem("nvpn", navLink[0].link_menu);
      this.handleMenu(e);
    },
    handleMenu(e) {
      if (this.getNotificationView) {
        Event.$emit("closeNotification", false);
      }
      this.$store.dispatch("SET_ACTIVE_NAVIGATION", e.key);
      this.current = e.key;
      this.DRAWER_TOGGLE(false);
    },
    beranda() {
      this.$router.push("/");
    },
    onClose() {
      this.DRAWER_TOGGLE(false);
    },
    about() {
      this.$router.push("/about");
    },
    fetchNav() {
      this.loading = true;
      Axios({
        method: "get",
        url: this.$serviceUrl + "menu/",
        params: {
          tlc: this.getAuth.username,
        },
        auth: {
          username: this.getAuth.username,
          password: this.getAuth.password,
        },
        headers: {
          "X-API-KEY": this.getAuth.apikey,
        },
      })
        .then((response) => {
          if (response !== undefined) {
            this.navigation = response.data.data[0];

            let LogoutEx = this.navigation.child.filter(
              (item) => item.link_menu.indexOf("/logout") >= 0
            );
            let logoutIn = this.navigation.child.filter(
              (item) => item.link_menu !== "/logout"
            );
            logoutIn.push(LogoutEx[0]);
            let allout = [{ child: logoutIn }];
            if (allout[0]) {
              this.navigation = allout[0];
            }

            this.specialNavigation = response.data.data.slice(1);
            this.NAVIGATION_ACTION(this.specialNavigation);

            this.loading = false;
          }
        })
        .catch((err) => {
          if (!err.response) {
            this.$router.push({ name: "noConnection" });
          }
          this.loading = false;
        });
    },
    handleNotification() {
      this.$store.dispatch("SET_NOTIFICATION_VIEW");
    },
    handleHelp() {
      window.open(process.env.VUE_APP_HELPDESK, "_blank");
    },
    handleVersionChanges() {
      const route = this.$router.resolve({
        name: "ChangeLogs",
      });
      window.open(route.href, "_blank");
      // var newWin = open('url', 'windowName');
      // newWin.document.write('html to write...');
    }
  },
  watch: {
    "isShowhideSideBar"() {
      if(!this.isShowhideSideBar){
        this.showhideSideBarMenu(false)
      }
    }
  },
};
</script>

<style scoped lang="less">
.router-link {
  &-* {
    color: white;
  }
}

.logo {
  &-wrapper {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 15px;
    min-height: 64px;
  }

  &-trigger {
    background: fade(@color-primary, 50%);
    padding: 10px;
    position: relative;
  }
}

.anim {
  position: fixed;
  bottom: 10px;
}

.ant {
  &-menu {
    &-item {
      width: 100%;
      &-active {
        font-weight: medium;
      }
    }
  }
}

.d {
  &-navigation {
    &-static {
      background-color: @color-primary;
      display: flex;
      align-items: center;
      justify-content: space-between;
      height: 50px;
      list-style: none;
      padding: 0 16px;
      margin-bottom: 0;

      a {
        color: white;
      }

      li {
        color: white;
        height: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 50px;
        position: relative;
        font-size: 16px;
        cursor: pointer;

        &:after {
          content: "";
          position: absolute;
          left: 0;
          right: 0;
          bottom: 0;
          height: 0px;
          border-top-left-radius: 4px;
          border-top-right-radius: 4px;
          background-color: darken(white, 10);
          transition: all 0.2s ease-in-out;
          transition-delay: 0.2s;
        }
        &:hover {
          &:after {
            height: 5px;
          }
        }
      }
    }

    &-spesial {
      .ant {
        &-menu {
          &-item {
            width: 100%;
            &:after {
              border-right-color: @color-primary;
            }
            &-selected {
              background-color: fade(@color-primary, 5%) !important;
              a {
                color: @color-primary;
              }
            }
            &-active {
              font-weight: medium;
            }
          }
        }
      }
    }

    &-title {
      font-weight: bold;
      font-size: 1em;
      padding-left: @padding;
      text-transform: uppercase;
    }

    &-helpdesk {
      padding: @padding;
      border-top: 1px solid darken(white, 10);
      &:hover {
        background-color: darken(white, 2);
        cursor: pointer;
      }
    }

    &-footer {
      &:hover {
        background-color: darken(white, 2);
        cursor: pointer;
      }
    }
  }
}

.photos {
  &-wrapper {
    width: 64px;
    height: 64px;
    position: relative;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px solid white;
    margin-bottom: 12px;
    border-radius: 12px;

    img {
      width: 100%;
      align-self: flex-start;
    }
  }
}
</style>
